<template>
  <p>
    <translate class="cardtype-title">
      Payment methods accepted on the park
    </translate>
    <template v-if="hasMethods">
      <span v-for="method in methods" :key="method.name" class="cardtype">
        {{ method.name }}
      </span>
    </template>
    <template v-else>
      <translate>None</translate>
    </template>
  </p>
</template>

<script lang="ts">
import { Component, Prop, Vue, toNative } from '~/utility/pu-class-decorator'

@Component
class CampsitePaymentMethods extends Vue {
  @Prop()
  methods: Array<{ name: string }>

  get hasMethods() {
    return this.methods.length > 0
  }
}

export default toNative(CampsitePaymentMethods)
</script>
<style scoped>
.cardtype:not(:last-of-type):after {
  content: ', ';
}
</style>
